/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState } from "react";
import {
  SupportContainer,
  SupportWrapper,
  SupportHeader,
  SupportSearch,
  SearchIcon,
  SupportInnerContainer,
  SupportListItem,
  SupportListContainer,
  SupportImage,
  SupportContent,
  SupportH3,
  SupportP1,
  SupportP2,
  SupportHelp,
  SupportP3,
  SupportP4,
  Notification,
} from "./support.styles";
import Navbar from "../Navbar/Navbar";
// import wallet from '../../assets/icons/wallet.png'
import user from "../../assets/icons/User.png";
import atm from "../../assets/icons/atm.png";
import file from "../../assets/icons/file.png";
import alert from "../../assets/icons/alert.png";
import wallet01 from "../../assets/icons/wallet01.png";

const supportData = [
  {
    imageSrc: "/assets/icons/file.png",
    altText: "file",
    title: "Onboarding and Sign Up",
    description: `Getting started with Fipay provider or merchant account and completing your KYC Verification with Due Diligence`,

    articlesOld: "2 articles in this collection",
    articles: "",
  },
  {
    imageSrc: "/assets/icons/User.png",
    altText: "user",
    title: "My Account",
    description:
      "Everything you need to know about bank account, upgrading from a personal to business account",

    articlesOld: "2 articles in this collection",
    articles: "",
  },
  {
    imageSrc: "/assets/icons/atm.png",
    altText: "atm",
    title: "Payment Method",
    description: "Everything you need to know about pay with bank",

    articlesOld: "2 articles in this collection",
    articles: "",
  },
  {
    imageSrc: "/assets/icons/file.png",
    altText: "file",
    title: "Integration Support",
    description:
      "Getting started with Fipay integration and completing your first api tokenization",

    articlesOld: "2 articles in this collection",
    articles: "",
  },
  {
    imageSrc: "/assets/icons/file.png",
    altText: "file",
    title: "Products",
    description:
      "Everything you need to know about fipay payment link, invoicing and tokenization",

    articlesOld: "2 articles in this collection",
    articles: "",
  },
  {
    imageSrc: "/assets/icons/wallet01.png",
    altText: "wallet01",
    title: "Pricing",
    description: "Getting started with Fipay pricing and fees",

    articlesOld: "2 articles in this collection",
    articles: "",
  },
  {
    imageSrc: "/assets/icons/file.png",
    altText: "file",
    title: "Refund a Customer",
    description:
      "Everything you need to know about refund, transaction failure or decline",

    articlesOld: "2 articles in this collection",
    articles: "",
  },
  {
    imageSrc: "/assets/icons/alert.png",
    altText: "alert",
    title: "Handling Disputes",
    description:
      "Getting started with Fipay dispute management and completing dispute transaction",

    articlesOld: "2 articles in this collection",
    articles: "",
  },
];

const index = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [articleNotFound, setArticleNotFound] = useState(false);
  const [notFoundQuery, setNotFoundQuery] = useState("");
  const [searchResultQuery, setSearchResultQuery] = useState("");

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(event.target.value);
    setArticleNotFound(false);
  };

  const filteredArticles = supportData.filter((item) =>
    item.title.toLowerCase().includes(searchQuery.toLowerCase())
  );
  if (filteredArticles.length === 0 && searchQuery && !articleNotFound) {
    setNotFoundQuery(searchQuery);
    setArticleNotFound(true);
  }
  if (filteredArticles.length > 0 && searchQuery && !searchResultQuery) {
    setSearchResultQuery(searchQuery);
  }
  return (
    <SupportContainer>
      <SupportInnerContainer>
        <Navbar />
        <SupportWrapper>
          <SupportHeader>Hi, How can we help?</SupportHeader>
        </SupportWrapper>
        <SupportSearch>
          <SearchIcon />
          <input
            type="text"
            placeholder="Search help article"
            value={searchQuery}
            onChange={handleSearchChange}
          />
        </SupportSearch>
      </SupportInnerContainer>
      <SupportListItem>
        {filteredArticles.length > 0 ? (
          filteredArticles.map((item, index) => (
            <SupportListContainer key={index}>
              <SupportImage>
                <img src={item.imageSrc} alt={item.altText} />
              </SupportImage>
              <SupportContent>
                <SupportH3>{item.title}</SupportH3>
                <SupportP1>{item.description}</SupportP1>
                <SupportP2>{item.articles}</SupportP2>
              </SupportContent>
            </SupportListContainer>
          ))
        ) : (
          <div>
            {articleNotFound ? (
              <Notification>
                We couldn’t find any articles for: {notFoundQuery}
              </Notification>
            ) : (
              <p>Search results for: {searchResultQuery}</p>
            )}
          </div>
        )}
        <SupportHelp>
          <SupportP3>Still need help?</SupportP3>
          <SupportP4>Contact Us</SupportP4>
        </SupportHelp>
      </SupportListItem>
    </SupportContainer>
  );
};

export default index;
